const countrySwedenOnly: { [key: string]: string } = {
  SE: 'Sweden',
};

export default countrySwedenOnly;
